import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import broadcastsRoutes from './broadcasts/broadcasts.routes';
import crmRoutes from './crm/crm.routes';
import formsRoutes from './forms/forms.routes';
import workflowRoutes from './workflows/workflows.routes';
import socialRoutes from './social/social.routes';
import emailMktRoutes from './emailMkt/emailMkt.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import { routes as segmentRoutes } from './segments/routes';
import { routes as homeRoutes } from './home/home.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...homeRoutes,
        ...captainRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...broadcastsRoutes.routes,
        ...crmRoutes.routes,
        ...formsRoutes.routes,
        ...workflowRoutes.routes,
        ...socialRoutes.routes,
        ...emailMktRoutes.routes,
        ...campaignsRoutes.routes,
        ...segmentRoutes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
